(function () {
  var WEB3FORMS_ACCESS_KEY = "a4e6b532-7773-4355-a6ce-993599663464";

  var PREVIEW_IMAGES = {
    front: {
      white: "//policesecurity.com/cdn/shop/t/24/assets/squeeze-light-color-preview-white.webp?v=158901330968711187851785244409",
      grey: "//policesecurity.com/cdn/shop/t/24/assets/squeeze-light-color-preview-grey.webp?v=178608723922305902931785244409",
      base: "//policesecurity.com/cdn/shop/t/24/assets/squeeze-light-color-preview-base.webp?v=147766000721686835661785244409",
      mask: "//policesecurity.com/cdn/shop/t/24/assets/squeeze-light-color-preview-mask.png?v=20556216851004089101785244409"
    },
    back: {
      white: "//policesecurity.com/cdn/shop/t/24/assets/squeeze-light-color-preview-back-white.webp?v=15406481928477519731785244409",
      grey: "//policesecurity.com/cdn/shop/t/24/assets/squeeze-light-color-preview-back-grey.webp?v=62647415122214158141785244409",
      base: "//policesecurity.com/cdn/shop/t/24/assets/squeeze-light-color-preview-back-base.webp?v=157167604425855428471785244409",
      mask: "//policesecurity.com/cdn/shop/t/24/assets/squeeze-light-color-preview-back-mask.png?v=119500622133602676351785244409"
    }
  };

  var GREY_HEX = "#c9cbcd";

  // ---------------------------------------------------------------------
  // Practical reference subset of commonly used Pantone colors.
  // Approximate on-screen hex conversions for design/reference purposes only.
  // ---------------------------------------------------------------------
  var PANTONE_COLORS = [
    {code:"185 C", name:"Red", hex:"#E4002B"},
    {code:"186 C", name:"Red", hex:"#C8102E"},
    {code:"199 C", name:"Red", hex:"#D50032"},
    {code:"1795 C", name:"Red", hex:"#C60C30"},
    {code:"7621 C", name:"Brick Red", hex:"#9E1B32"},
    {code:"032 C", name:"Red-Orange", hex:"#EF3340"},
    {code:"Bright Red C", name:"Bright Red", hex:"#EE2737"},
    {code:"1788 C", name:"Cherry Red", hex:"#EE3A43"},
    {code:"219 C", name:"Magenta", hex:"#D6006D"},
    {code:"226 C", name:"Pink", hex:"#E10098"},
    {code:"Pink C", name:"Pink", hex:"#D0006F"},
    {code:"Rubine Red C", name:"Rubine Red", hex:"#CE0058"},
    {code:"806 C", name:"Neon Pink", hex:"#FF3EA5"},
    {code:"245 C", name:"Purple-Pink", hex:"#9E007E"},
    {code:"2385 C", name:"Violet", hex:"#7B2082"},
    {code:"2685 C", name:"Deep Purple", hex:"#330072"},
    {code:"2695 C", name:"Dark Violet", hex:"#3C1053"},
    {code:"2725 C", name:"Violet", hex:"#6E4C9F"},
    {code:"2587 C", name:"Lavender", hex:"#9678D3"},
    {code:"267 C", name:"Purple", hex:"#5F259F"},
    {code:"Purple C", name:"Purple", hex:"#6A1B9A"},
    {code:"286 C", name:"Blue", hex:"#0032A0"},
    {code:"280 C", name:"Navy", hex:"#012169"},
    {code:"Reflex Blue C", name:"Reflex Blue", hex:"#001489"},
    {code:"293 C", name:"Royal Blue", hex:"#003DA5"},
    {code:"2935 C", name:"Blue", hex:"#0057B8"},
    {code:"2925 C", name:"Sky Blue", hex:"#0091DA"},
    {code:"2915 C", name:"Light Blue", hex:"#5BA4CF"},
    {code:"Process Blue C", name:"Process Blue", hex:"#0085CA"},
    {code:"Process Cyan C", name:"Cyan", hex:"#00AEEF"},
    {code:"299 C", name:"Cyan Blue", hex:"#00A9E0"},
    {code:"3125 C", name:"Teal Blue", hex:"#00A9CE"},
    {code:"320 C", name:"Teal", hex:"#00778B"},
    {code:"319 C", name:"Aqua", hex:"#00B2A9"},
    {code:"3145 C", name:"Deep Teal", hex:"#00697C"},
    {code:"Green C", name:"Green", hex:"#00AB84"},
    {code:"355 C", name:"Green", hex:"#009A44"},
    {code:"347 C", name:"Kelly Green", hex:"#009B48"},
    {code:"348 C", name:"Forest Green", hex:"#00594C"},
    {code:"3298 C", name:"Pine Green", hex:"#00594F"},
    {code:"376 C", name:"Lime Green", hex:"#84BD00"},
    {code:"368 C", name:"Grass Green", hex:"#78BE20"},
    {code:"7739 C", name:"Olive Green", hex:"#6F9B45"},
    {code:"5757 C", name:"Sage", hex:"#7C8C4B"},
    {code:"Yellow C", name:"Yellow", hex:"#FEDD00"},
    {code:"109 C", name:"Yellow", hex:"#FFD100"},
    {code:"116 C", name:"Golden Yellow", hex:"#FFCD00"},
    {code:"123 C", name:"Yellow-Gold", hex:"#FFC72C"},
    {code:"1235 C", name:"Sunflower", hex:"#FFB81C"},
    {code:"1225 C", name:"Butter Yellow", hex:"#FFD966"},
    {code:"021 C", name:"Orange", hex:"#FE5000"},
    {code:"165 C", name:"Orange", hex:"#FF6D2E"},
    {code:"1505 C", name:"Bright Orange", hex:"#FF6900"},
    {code:"158 C", name:"Orange", hex:"#ED8B00"},
    {code:"1585 C", name:"Amber", hex:"#FF8200"},
    {code:"1495 C", name:"Tangerine", hex:"#FF8F1C"},
    {code:"1665 C", name:"Coral Orange", hex:"#FF6F4C"},
    {code:"Warm Red C", name:"Warm Red", hex:"#F9423A"},
    {code:"1545 C", name:"Terracotta", hex:"#B15533"},
    {code:"4625 C", name:"Chestnut Brown", hex:"#40230F"},
    {code:"469 C", name:"Brown", hex:"#5C3A21"},
    {code:"7530 C", name:"Sand", hex:"#A9906B"},
    {code:"7526 C", name:"Khaki", hex:"#8A7A5C"},
    {code:"4645 C", name:"Taupe", hex:"#8C7A6B"},
    {code:"Black C", name:"Black", hex:"#2D2926"},
    {code:"Black 6 C", name:"Rich Black", hex:"#1B1B1B"},
    {code:"Neutral Black C", name:"Neutral Black", hex:"#25282A"},
    {code:"Cool Gray 1 C", name:"Cool Gray 1", hex:"#D9D9D6"},
    {code:"Cool Gray 5 C", name:"Cool Gray 5", hex:"#B1B3B3"},
    {code:"Cool Gray 9 C", name:"Cool Gray 9", hex:"#75787B"},
    {code:"Cool Gray 11 C", name:"Cool Gray 11", hex:"#53565A"},
    {code:"Warm Gray 4 C", name:"Warm Gray 4", hex:"#BFB9AC"},
    {code:"Warm Gray 8 C", name:"Warm Gray 8", hex:"#8D8079"},
    {code:"White", name:"White", hex:"#FFFFFF"},
    {code:"871 C", name:"Gold (metallic approx.)", hex:"#85754E"},
    {code:"874 C", name:"Light Gold (metallic approx.)", hex:"#A69164"},
    {code:"877 C", name:"Silver (metallic approx.)", hex:"#8A8D8F"},
    {code:"872 C", name:"Bronze (metallic approx.)", hex:"#75664D"},
    {code:"3005 C", name:"Cerulean", hex:"#0077C8"},
    {code:"3015 C", name:"Steel Blue", hex:"#00688C"},
    {code:"2955 C", name:"Deep Navy", hex:"#003865"},
    {code:"2965 C", name:"Midnight Blue", hex:"#002855"},
    {code:"7462 C", name:"Denim Blue", hex:"#254AA5"},
    {code:"7451 C", name:"Slate Blue", hex:"#5B6770"},
    {code:"7549 C", name:"Mustard", hex:"#DDB321"},
    {code:"7406 C", name:"Marigold", hex:"#F4C300"},
    {code:"7579 C", name:"Pumpkin", hex:"#C4622D"},
    {code:"7599 C", name:"Coral", hex:"#E8734A"},
    {code:"7620 C", name:"Maroon", hex:"#9D2235"},
    {code:"7627 C", name:"Rust Red", hex:"#9B2D30"},
    {code:"7669 C", name:"Plum", hex:"#5C3A5C"},
    {code:"7671 C", name:"Grape", hex:"#5B3069"},
    {code:"7702 C", name:"Deep Teal", hex:"#00485E"},
    {code:"7726 C", name:"Emerald", hex:"#00693E"},
    {code:"7732 C", name:"Hunter Green", hex:"#265C42"},
    {code:"7741 C", name:"Moss Green", hex:"#5D7B41"},
    {code:"7757 C", name:"Seafoam", hex:"#71A79C"},
    {code:"7761 C", name:"Sage Green", hex:"#7C9070"},
    {code:"7404 C", name:"Pale Yellow", hex:"#F5D547"},
    {code:"1215 C", name:"Cream Yellow", hex:"#FCDA98"},
    {code:"162 C", name:"Burnt Orange", hex:"#DC5B27"},
    {code:"1665 C", name:"Salmon", hex:"#FF6F5E"},
    {code:"faded-rose", name:"Dusty Rose", hex:"#C08081"},
    {code:"690 C", name:"Blush", hex:"#DBA9AD"},
    {code:"705 C", name:"Pale Pink", hex:"#F7CFD8"},
    {code:"677 C", name:"Lilac", hex:"#CBB4D4"},
    {code:"5205 C", name:"Sage Gray", hex:"#8E9B8F"},
    {code:"5477 C", name:"Slate Green", hex:"#5B7065"},
    {code:"424 C", name:"Charcoal Gray", hex:"#6C6E70"},
    {code:"420 C", name:"Light Gray", hex:"#C6C6C6"},
    {code:"656 C", name:"Powder Blue", hex:"#C4D8E8"},
    {code:"635 C", name:"Baby Blue", hex:"#A8DADC"},
    {code:"326 C", name:"Turquoise", hex:"#00A99D"},
    {code:"3255 C", name:"Mint", hex:"#00B686"},
    {code:"7488 C", name:"Spring Green", hex:"#8DC63F"},
    {code:"382 C", name:"Chartreuse", hex:"#C4D600"}
  ];

  function normalize(str) { return (str || "").toLowerCase(); }
  function isValidHex(hex) { return /^#[0-9a-fA-F]{6}$/.test(hex); }

  // ---------------------------------------------------------------------
  // Body color live preview (front + back, White / Light Grey / Custom)
  // ---------------------------------------------------------------------
  var glowEl = document.getElementById("sqcfGlow");
  var frontImg = document.getElementById("sqcfPreviewFront");
  var backImg = document.getElementById("sqcfPreviewBack");
  var frontOverlay = document.getElementById("sqcfPreviewOverlayFront");
  var backOverlay = document.getElementById("sqcfPreviewOverlayBack");
  var bodyCustomWrap = document.getElementById("sqcfBodyCustomWrap");
  var bodyModeInput = document.getElementById("sqcfBodyColorMode");
  var bodyHexInput = document.getElementById("sqcfBodyColorHex");

  frontOverlay.style.maskImage = "url(" + PREVIEW_IMAGES.front.mask + ")";
  frontOverlay.style.webkitMaskImage = "url(" + PREVIEW_IMAGES.front.mask + ")";
  backOverlay.style.maskImage = "url(" + PREVIEW_IMAGES.back.mask + ")";
  backOverlay.style.webkitMaskImage = "url(" + PREVIEW_IMAGES.back.mask + ")";

  function recreateOverlay(el, color) {
    var fresh = el.cloneNode(false);
    fresh.style.backgroundColor = color;
    el.parentNode.replaceChild(fresh, el);
    return fresh;
  }

  function setGlow(hex) {
    if (glowEl) glowEl.style.background = hex || "#ff9142";
  }

  var bodyColorMode = null;

  function setBodyColorMode(mode, hex) {
    bodyColorMode = mode;

    document.querySelectorAll(".sqcf-swatch-btn").forEach(function (btn) {
      var isActive = btn.getAttribute("data-mode") === mode;
      btn.classList.toggle("active", isActive);
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    if (mode === "white") {
      bodyCustomWrap.classList.remove("active");
      frontImg.src = PREVIEW_IMAGES.front.white;
      backImg.src = PREVIEW_IMAGES.back.white;
      frontOverlay = recreateOverlay(frontOverlay, "transparent");
      backOverlay = recreateOverlay(backOverlay, "transparent");
      setGlow("#ff9142");
      bodyModeInput.value = "White";
      bodyHexInput.value = "#FFFFFF";
      recomputeLeadTime();
    } else if (mode === "grey") {
      bodyCustomWrap.classList.remove("active");
      frontImg.src = PREVIEW_IMAGES.front.grey;
      backImg.src = PREVIEW_IMAGES.back.grey;
      frontOverlay = recreateOverlay(frontOverlay, "transparent");
      backOverlay = recreateOverlay(backOverlay, "transparent");
      setGlow(GREY_HEX);
      bodyModeInput.value = "Light Grey";
      bodyHexInput.value = GREY_HEX.toUpperCase();
      recomputeLeadTime();
    } else if (mode === "custom") {
      bodyCustomWrap.classList.add("active");
      frontImg.src = PREVIEW_IMAGES.front.base;
      backImg.src = PREVIEW_IMAGES.back.base;
      var useHex = hex && isValidHex(hex) ? hex : "#ff7a3d";
      frontOverlay = recreateOverlay(frontOverlay, useHex);
      backOverlay = recreateOverlay(backOverlay, useHex);
      setGlow(useHex);
      bodyModeInput.value = "Custom";
      bodyHexInput.value = useHex.toUpperCase();
      recomputeLeadTime();
    }
  }

  document.querySelectorAll(".sqcf-swatch-btn").forEach(function (btn) {
    btn.addEventListener("click", function () { setBodyColorMode(btn.getAttribute("data-mode")); });
  });

  // ---------------------------------------------------------------------
  // Generic Pantone-search-or-Hex field (used for body custom, logo 1, logo 2)
  // ---------------------------------------------------------------------
  function initColorField(wrap, opts) {
    opts = opts || {};
    var toggleBtns = wrap.querySelectorAll(":scope > .sqcf-color-toggle .sqcf-color-toggle-btn");
    var inputPanes = wrap.querySelectorAll(":scope > .sqcf-color-input");
    var comboWrap = wrap.querySelector(".sqcf-combo-wrap");
    var colorPicker = wrap.querySelector(".sqcf-color-picker");
    var hexText = wrap.querySelector(".sqcf-hex-text");
    var hiddenType = wrap.querySelector(".sqcf-hidden-type");
    var hiddenCode = wrap.querySelector(".sqcf-hidden-code");
    var hiddenName = wrap.querySelector(".sqcf-hidden-name");
    var hiddenHex = wrap.querySelector(".sqcf-hidden-hex");

    function setHidden(type, hex, code, name) {
      if (hiddenType) hiddenType.value = type || "";
      if (hiddenHex) hiddenHex.value = hex ? hex.toUpperCase() : "";
      if (hiddenCode) hiddenCode.value = code || "";
      if (hiddenName) hiddenName.value = name || "";
      if (opts.onChange) opts.onChange(hex, type);
    }

    toggleBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var target = btn.getAttribute("data-input");
        toggleBtns.forEach(function (b) { b.classList.toggle("active", b === btn); });
        inputPanes.forEach(function (p) { p.classList.toggle("active", p.getAttribute("data-input") === target); });
      });
    });

    // --- Pantone combobox ---
    var input = document.createElement("input");
    input.type = "text";
    input.className = "sqcf-combo-input";
    input.setAttribute("role", "combobox");
    input.autocomplete = "off";
    input.placeholder = "Type a Pantone code or color name…";

    var list = document.createElement("div");
    list.className = "sqcf-combo-list";
    list.hidden = true;

    var chip = document.createElement("div");
    chip.className = "sqcf-swatch-chip";
    chip.hidden = true;
    chip.innerHTML =
      '<span class="sqcf-swatch-dot"></span>' +
      '<span class="sqcf-swatch-code"></span>' +
      '<span class="sqcf-swatch-name"></span>' +
      '<button type="button" class="sqcf-swatch-clear" aria-label="Clear selection">×</button>';

    comboWrap.appendChild(input);
    comboWrap.appendChild(list);
    comboWrap.appendChild(chip);

    var activeIndex = -1;
    var currentMatches = [];

    function renderList(matches) {
      list.innerHTML = "";
      if (matches.length === 0) {
        var empty = document.createElement("div");
        empty.className = "sqcf-combo-empty";
        empty.textContent = "No matches — try a different code or name.";
        list.appendChild(empty);
        return;
      }
      matches.forEach(function (item, idx) {
        var opt = document.createElement("div");
        opt.className = "sqcf-combo-option" + (idx === activeIndex ? " active" : "");
        opt.innerHTML =
          '<span class="sqcf-combo-dot" style="background:' + item.hex + '"></span>' +
          '<span class="sqcf-combo-code">' + item.code + '</span>' +
          '<span class="sqcf-combo-name">' + item.name + '</span>';
        opt.addEventListener("mousedown", function (e) { e.preventDefault(); selectItem(item); });
        list.appendChild(opt);
      });
    }

    function closeList() { list.hidden = true; }

    function selectItem(item) {
      chip.querySelector(".sqcf-swatch-dot").style.background = item.hex;
      chip.querySelector(".sqcf-swatch-code").textContent = item.code;
      chip.querySelector(".sqcf-swatch-name").textContent = item.name;
      chip.hidden = false;
      input.value = "";
      input.hidden = true;
      closeList();
      setHidden("pantone", item.hex, item.code, item.name);
    }

    chip.querySelector(".sqcf-swatch-clear").addEventListener("click", function () {
      chip.hidden = true;
      input.hidden = false;
      input.value = "";
      input.focus();
      setHidden("", "", "", "");
    });

    input.addEventListener("input", function () {
      var q = normalize(input.value);
      if (q.length === 0) { closeList(); return; }
      currentMatches = PANTONE_COLORS.filter(function (c) {
        return normalize(c.code).indexOf(q) !== -1 || normalize(c.name).indexOf(q) !== -1;
      }).slice(0, 30);
      activeIndex = -1;
      renderList(currentMatches);
      list.hidden = false;
    });

    input.addEventListener("keydown", function (e) {
      if (list.hidden) return;
      if (e.key === "ArrowDown") { e.preventDefault(); activeIndex = Math.min(activeIndex + 1, currentMatches.length - 1); renderList(currentMatches); }
      else if (e.key === "ArrowUp") { e.preventDefault(); activeIndex = Math.max(activeIndex - 1, 0); renderList(currentMatches); }
      else if (e.key === "Enter") { e.preventDefault(); if (activeIndex >= 0 && currentMatches[activeIndex]) selectItem(currentMatches[activeIndex]); }
      else if (e.key === "Escape") { closeList(); }
    });

    document.addEventListener("click", function (e) {
      if (!comboWrap.contains(e.target)) closeList();
    });

    // --- Hex picker ---
    colorPicker.addEventListener("input", function () {
      hexText.value = colorPicker.value.toUpperCase();
      setHidden("hex", colorPicker.value);
    });
    hexText.addEventListener("input", function () {
      var val = hexText.value.trim();
      if (val && val[0] !== "#") val = "#" + val;
      if (isValidHex(val)) {
        colorPicker.value = val;
        setHidden("hex", val);
      }
    });
  }

  document.querySelectorAll(".sqcf-color-field").forEach(function (wrap) {
    var fieldName = wrap.getAttribute("data-field");
    if (fieldName === "body_color") {
      initColorField(wrap, {
        onChange: function (hex) {
          if (bodyColorMode === "custom" && hex) setBodyColorMode("custom", hex);
        }
      });
    } else {
      initColorField(wrap);
    }
  });

  // ---------------------------------------------------------------------
  // Quantity + lead time / MOQ logic
  // ---------------------------------------------------------------------
  function recomputeLeadTime() {
    var box = document.getElementById("sqcfLeadTimeBox");
    var titleEl = document.getElementById("sqcfLeadTimeTitle");
    var textEl = document.getElementById("sqcfLeadTimeText");
    var leadInput = document.getElementById("sqcfEstimatedLeadTime");
    var qSelect = document.getElementById("sqcfQuantity");
    var qVal = qSelect ? qSelect.value : "";

    if (!box || !titleEl || !textEl || !leadInput) return;

    if (!bodyColorMode || !qVal) {
      box.hidden = true;
      leadInput.value = "";
      return;
    }

    box.hidden = false;
    box.classList.remove("warning");

    if (qVal === "not_sure") {
      titleEl.textContent = "Estimated Lead Time";
      textEl.textContent = "Lead time depends on final quantity — share your best estimate above and we'll confirm exact timing.";
      leadInput.value = "Pending quantity confirmation";
      return;
    }

    var isBaseColor = (bodyColorMode === "white" || bodyColorMode === "grey");
    var colorLabel = bodyColorMode === "white" ? "White" : (bodyColorMode === "grey" ? "Light Grey" : "Custom color");

    if (isBaseColor) {
      if (qVal === "under_1000") {
        box.classList.add("warning");
        titleEl.textContent = "Minimum Order Notice";
        textEl.textContent = colorLabel + " requires a 1,000 piece minimum. Please choose 1,000 or more above.";
        leadInput.value = "Below minimum (1,000 required)";
        return;
      }
      var baseLead = (qVal === "1000_4999") ? "21–30 days" : "30–45 days";
      titleEl.textContent = "Estimated Lead Time";
      textEl.textContent = colorLabel + ": " + baseLead + " from order confirmation.";
      leadInput.value = baseLead + " (" + colorLabel + ")";
    } else {
      if (qVal === "under_1000" || qVal === "1000_4999") {
        box.classList.add("warning");
        titleEl.textContent = "Minimum Order Notice";
        textEl.textContent = "Custom colors require a 5,000 piece minimum. Please choose 5,000 or more above.";
        leadInput.value = "Below minimum (5,000 required)";
        return;
      }
      titleEl.textContent = "Estimated Lead Time";
      textEl.textContent = "Custom color: 120 days for any quantity of 5,000 or more — this is a flat lead time that includes proofing and color-match approval, whether you order 5,000 or 50,000.";
      leadInput.value = "120 days (Custom color, includes proofing/approval)";
    }
  }

  var quantitySelectEl = document.getElementById("sqcfQuantity");
  if (quantitySelectEl) quantitySelectEl.addEventListener("change", recomputeLeadTime);

  // "Other" reveal for intended use
  var useSelect = document.getElementById("sqcfUse");
  var useOtherWrap = document.getElementById("sqcfUseOtherWrap");
  if (useSelect && useOtherWrap) {
    useSelect.addEventListener("change", function () {
      useOtherWrap.style.display = useSelect.value === "Other" ? "flex" : "none";
    });
  }

  // ---------------------------------------------------------------------
  // Form submission (Web3Forms — reliable delivery, real success/failure confirmation)
  // ---------------------------------------------------------------------
  var form = document.getElementById("sqcfForm");
  form.noValidate = true;
  var submitBtn = form.querySelector(".sqcf-submit-btn");
  var errorMsg = document.getElementById("sqcfErrorMsg");

  function describeColorField(wrap) {
    if (!wrap) return "";
    var type = wrap.querySelector(".sqcf-hidden-type").value;
    var hexEl = wrap.querySelector(".sqcf-hidden-hex");
    var hex = hexEl ? hexEl.value : "";
    var code = wrap.querySelector(".sqcf-hidden-code").value;
    var name = wrap.querySelector(".sqcf-hidden-name").value;
    if (type === "pantone") return "Pantone " + code + " — " + name + (hex ? " (" + hex + ")" : "");
    if (type === "hex") return hex;
    return "";
  }

  function describeBodyColor() {
    if (bodyColorMode === "white") return "White (#FFFFFF)";
    if (bodyColorMode === "grey") return "Light Grey (" + GREY_HEX.toUpperCase() + ")";
    if (bodyColorMode === "custom") return describeColorField(bodyCustomWrap) || "Custom (not yet specified)";
    return "Not specified";
  }

  function selectText(select) {
    return select && select.selectedIndex >= 0 ? select.options[select.selectedIndex].text : "";
  }

  function buildMessageBody() {
    var lines = [];
    lines.push("Company / Organization: " + form.elements["company"].value.trim());
    lines.push("");
    lines.push("Body Color: " + describeBodyColor());
    var qEl = document.getElementById("sqcfQuantity");
    lines.push("Estimated Quantity: " + (selectText(qEl) || "Not specified"));
    var leadEl = document.getElementById("sqcfEstimatedLeadTime");
    if (leadEl && leadEl.value) lines.push("Estimated Lead Time: " + leadEl.value);
    var useEl = document.getElementById("sqcfUse");
    var useText = selectText(useEl);
    if (useText === "Other") {
      var otherEl = document.getElementById("sqcfUseOther");
      useText = "Other — " + (otherEl && otherEl.value.trim() ? otherEl.value.trim() : "not specified");
    }
    lines.push("Intended Use: " + (useText || "Not specified"));
    var timelineEl = document.getElementById("sqcfTimeline");
    lines.push("Target Timeline: " + (timelineEl && timelineEl.value.trim() ? timelineEl.value.trim() : "Not specified"));

    var logo1Wrap = document.querySelector('.sqcf-color-field[data-field="logo_color_1"]');
    var logo2Wrap = document.querySelector('.sqcf-color-field[data-field="logo_color_2"]');
    lines.push("Logo Color 1: " + (describeColorField(logo1Wrap) || "Not specified"));
    var logo2Desc = describeColorField(logo2Wrap);
    if (logo2Desc) lines.push("Logo Color 2: " + logo2Desc);

    var notesEl = document.getElementById("sqcfNotes");
    if (notesEl && notesEl.value.trim()) {
      lines.push("");
      lines.push("Additional Details:");
      lines.push(notesEl.value.trim());
    }

    return lines.join("\n");
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    errorMsg.hidden = true;

    var required = ["company", "contact_name", "email"];
    var missing = required.filter(function (name) {
      return !form.elements[name].value.trim();
    });
    if (missing.length > 0) {
      form.elements[missing[0]].focus();
      return;
    }

    if (!bodyColorMode) {
      document.querySelector(".sqcf-swatch-group").scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    var companyVal = form.elements["company"].value.trim();
    var fd = new FormData();
    fd.append("access_key", WEB3FORMS_ACCESS_KEY);
    fd.append("subject", "Squeeze Light Color Request — " + companyVal);
    fd.append("from_name", "Squeeze Light Color Request Form");
    fd.append("name", form.elements["contact_name"].value.trim());
    fd.append("email", form.elements["email"].value.trim());
    fd.append("phone", form.elements["phone"].value.trim());
    fd.append("company", companyVal);
    fd.append("message", buildMessageBody());

    submitBtn.disabled = true;
    submitBtn.textContent = "Sending…";

    fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: fd
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.success) {
          form.hidden = true;
          document.getElementById("sqcfSuccessMsg").hidden = false;
        } else {
          throw new Error(data.message || "Submission failed");
        }
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = "Send my color request";
        errorMsg.hidden = false;
      });
  });
})();
